export const testimonials = [
  {
    author: `
      Kathy R - NAHA and Aromahead Certified 
      Aromatherapist | LabAroma Certified LabCannamist
    `,
    review: `
      For over twenty years I've been monitored for ocular pressure, 
      which is a significant indicator of glaucoma. My measures were 
      usually between 27-30 mm Hg, which exceeds the healthy range. 
      I heard about CBG and how it could reduce ocular pressure, so I 
      started using the Republic 310's Full-Spectrum CBG oil (which 
      lets my body enjoy "the entourage effect" of hemp's natural 
      properties), in hopes of it helping my body in some way.
      I used it daily for two months before my latest test. The 
      measure read 16: normal. For the first time in ages, my ocular 
      pressure reduced to a healthy level. My ophthalmologist could 
      not believe it. I was surprised myself. I absolutely love the 
      Republic 310 for helping me feel healthy again. What a great 
      product! Definitely going to continue to use it.
    `,
  },
  {
    author: 'Brandon Z',
    review: `
      I've dealt with insomnia for my entire life. I've tried using 
      melatonin tablets, in addition to all other sorts of prescribed 
      products and remedies, and even hemp products from other brands. 
      Zac heard about my problem and offered me a solution. He told me 
      about this new organic product he was working on that he thought 
      could help me. I was reluctant at first, because I'm familiar with 
      hemp oils and they never really helped me in the past. I figured 
      it was worth a shot, so I accepted and began using his Full-Spectrum 
      CBG oil. I've been using it for a couple months and I actually look 
      forward to going to bed now: I'm no longer staying awake for hours 
      on end thinking about what I'm going to do tomorrow and the next day, 
      all to wake up groggy in the morning! Instead, I fall asleep easily 
      and wake up well-rested. I must (still) be dreaming!
    `,
  },
];
